import { mapActions } from 'vuex';
import Events from '_utils/events';
import RepresentativeService from '_services/rest/modules/representative';
import { _DELETE_REPRESENTATIVE_ } from './RepresentativeModel';

export default {
  name: 'representative-actions',
  data() {
    return {
      selectRepresentative: null,
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    deleteRow() {
      this.setToggle({ type: 'progress', bool: true });
      RepresentativeService.deleteRepresentative(this.selectRepresentative)
        .then(() => {
          this.close();
          this.$router.push('/admin/representantes/lista/1');
          Events.$emit('update:pagination', false);
          this.activeAlert({ message: 'Representante deletado com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
  mounted() {
    Events.$on(_DELETE_REPRESENTATIVE_, representative => {
      this.selectRepresentative = representative.id;
    });
  },
};
